import {useEffect,useState} from 'react';
import {getBanner,getImage} from '../../../firebase';

export default function TagLine() {
    const [imageUrls,setImageUrls]=useState([]);

    useEffect(()=>{
        getBanner().then(paths=>{
            paths.forEach(p=>{
                getImage(p).then(image=>setImageUrls(pre=>[...pre,image]));
            })
        }).catch(err=>{
            console.log(err);
        })
    },[]);

    return (<>
        {imageUrls.length > 0 && <section id="team" className="team">
            <div id="bannerCarousel" className="carousel slide px-2" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    {imageUrls.map((_,i)=><button key={i} type="button" data-bs-target="#bannerCarousel" data-bs-slide-to={i} className={i===0?"active":""} aria-label={`Slide ${i}`} />)}
                </div>
                <div className="carousel-inner">
                    {imageUrls.map((imageSrc,i)=><div key={i} className={i===0?"carousel-item active":"carousel-item"}>
                        <img src={imageSrc} className="d-block w-100" height="350px" alt="..." />

                    </div>)}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </section >}
        </>
    );
}